module.exports = __webpack_public_path__ + "img/icon_humidity.67b21c92.png";